import request from '@/utils/request'
// 中到马来拉单
export function ZdmApi_sudi_notice(data) {
  return request({
    url: 'zdm_index/ZdmApi/sudi_notice',
    method: 'post',
    data: data,
  })
}

